import {
  CLEAN_CONSULT_LEGAL_ID,
  CLEAN_CONSULT_LEGAL_ID_ERROR,
  CONSULT_LEGAL_ID,
  CONSULT_LEGAL_ID_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function consultLegalIdReducer(state = initialState, action) {
  switch (action.type) {
    case CONSULT_LEGAL_ID:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case CONSULT_LEGAL_ID_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_CONSULT_LEGAL_ID:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_CONSULT_LEGAL_ID_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
